import Column from '@components/Column';
import Image from '@components/Image';
import Row from '@components/Row';
import Text from '@components/Text';
import colors from '@constants/colors';
import { GiftBoxResponse, GiftCouponStatus } from '@models/gift';
import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

import styles from './styles.module.scss';

interface Props {
    giftBox: GiftBoxResponse;
}

function GiftItem({ giftBox }:Props) {
    const { giftItemType, giftCoupon, giftCard } = giftBox;
    const { t } = useTranslation('gift');

    const getCouponStatusKey = (status: string) => {
        const statusMap: Record<string, string> = {
            ISSUED: 'issued',
            USED: 'used',
            CANCELED: 'canceled',
            EXPIRED: 'expired',
            CANCEL_FAILED: 'cancelFailed',
            SENT: 'sent',
            SEND_FAILED: 'sendFailed',
            OFF_USED: 'offUsed',
            DEACTIVATED: 'deactivated',
        };
        return `couponStatus.${statusMap[status] || status.toLowerCase()}`;
    };

    return (
        <Column fullWidth align='center'
            className={styles.container}>

            <Text size='2xl' fontWeight='medium'
                color={colors.gray7}>
                {giftCoupon?.name || giftCard?.name}
            </Text>

            {giftItemType === 'PRODUCT' && (
                <Row className={styles.exrpires} spacing={4}>
                    <Text size='lg' color={colors.gray6} fontWeight='bold'>
                        {t('giftReceived.validPeriod')}
                    </Text>
                    <Text color={colors.gray6}>
                        {t('giftReceived.validUntil', { date: '2025.05.24. 23:59' })}
                    </Text>
                </Row>
            )}
            {giftCoupon && (
                <Fragment>
                    <div className={styles.item}>
                        <Image src='/dummy/img_4.png'
                            width={106}
                            height={106}
                            alt={t('giftReceived.productImageAlt')} />
                        {giftCoupon.status !== GiftCouponStatus.DEACTIVATED && (
                            <span className={`${styles.badge} `}>
                                {t(getCouponStatusKey(giftCoupon.status))}
                            </span>
                        )}
                    </div>
                    <Text size='3xl' fontWeight='bold'>5,500{t('item.priceUnit')}</Text>
                </Fragment>
            )}
            {giftCard && (
                <Image src='/dummy/img_5.png'
                    className={styles.card}
                    width={200}
                    height={134}
                    alt={t('giftReceived.prepaidCardAlt')} />
            )}

        </Column>
    );
}

export default GiftItem;
